export default __webpack_public_path__ + "static/media/polygon-matic-logo.97ff139c.svg";